import {
  DateRangeSelectorInput,
  DropdownInput,
  FilterPanel,
} from "@validereinc/common-components";
import { MeasurementAggregators } from "@validereinc/domain";
import { Measurements } from "@validereinc/domain-controllers";
import * as PropTypes from "prop-types";
import React from "react";
import { DeviceUpdateStatusBanner } from "../DeviceUpdateStatusBanner";
import AnalysisPanel from "./AnalysisPanel";
import RecordPanel from "./RecordPanel";

const { MeasurementAggregatorOptions } = Measurements.logic;

const DeviceDetailMeasurementsTab = ({
  appliedFilters,
  onFiltersChange,
  measurementTypes,
  intervalOptions,
  filteredMeasurementData,
  isDataLoading,
  measurementSources,
}) => {
  const { formatter, showTime } =
    intervalOptions.find(({ id }) => id === appliedFilters.interval) ?? {};

  return (
    <>
      <DeviceUpdateStatusBanner />
      <FilterPanel
        value={appliedFilters}
        onChange={onFiltersChange}
        filters={[
          {
            component: (
              // @ts-expect-error TODO: fix date range selector input typing - uncontrolled?
              <DateRangeSelectorInput
                name="date_range"
                allowOneDayRange={true}
                allowTimeSelection={true}
                isInline
              />
            ),
          },
          {
            component: (
              <DropdownInput
                name="measurement_left"
                isClearable={false}
                placeholder="Left Y-axis"
                labelKey="name"
                valueKey="id"
                options={measurementTypes.filter(
                  ({ id }) => appliedFilters.measurement_right !== id
                )}
                isInline
              />
            ),
          },
          {
            component: (
              <DropdownInput
                name="measurement_right"
                placeholder="Right Y-axis"
                labelKey="name"
                valueKey="id"
                options={measurementTypes.filter(
                  ({ id }) => appliedFilters.measurement_left !== id
                )}
                isInline
              />
            ),
          },
          {
            component: (
              <DropdownInput
                name="interval"
                isClearable={false}
                placeholder="Interval"
                labelKey="name"
                valueKey="id"
                options={intervalOptions}
                isInline
                isSortedAlphabetically={false}
              />
            ),
          },
          {
            component: (
              <DropdownInput
                name="aggregation_function"
                isClearable={false}
                placeholder="Aggregation Function"
                labelKey="label"
                valueKey="value"
                options={MeasurementAggregatorOptions.filter((opt) =>
                  [
                    MeasurementAggregators.AVERAGE,
                    MeasurementAggregators.SUM,
                  ].includes(opt.value as any)
                )}
                isInline
                isSortedAlphabetically={true}
              />
            ),
          },
        ]}
      />

      <AnalysisPanel
        data={filteredMeasurementData}
        isLoading={isDataLoading}
        tickFormatter={formatter}
        from={appliedFilters.date_range.from}
        to={appliedFilters.date_range.to}
      />

      <RecordPanel
        data={filteredMeasurementData.flatMap(({ data }) => data)}
        withTime={showTime}
        measurementSources={measurementSources}
        isLoading={isDataLoading}
      />
    </>
  );
};

DeviceDetailMeasurementsTab.propTypes = {
  appliedFilters: PropTypes.object,
  onFiltersChange: PropTypes.func,
  measurementTypes: PropTypes.object,
  intervalOptions: PropTypes.array,
  filteredMeasurementData: PropTypes.array,
  isDataLoading: PropTypes.bool.isRequired,
  measurementSources: PropTypes.array,
};

export default DeviceDetailMeasurementsTab;
